import React, { useContext, useEffect, useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { AppContext } from 'core/context/';

const LibrarySelect = ({onLibrarySelected, variant="standard", width, defaultSelectId=null, fullWidth}) => {
  const [libraryList, setLibrayList] = useState([]);
  const [librarySelected, setLibraySelected] = useState('');
  const { libraries=[] } = useContext(AppContext);

  useEffect(() => {
    if(libraries?.length){
      setLibrayList(libraries);
      if(defaultSelectId){
        const foundLibrary = libraries.filter(lib=> lib?.libraryId===defaultSelectId);
        if(foundLibrary?.length > 0) {
          setLibraySelected(foundLibrary[0]);
          return;
        }
        
      }
      setLibraySelected(libraries[0]);
    }
  }, [libraries, defaultSelectId]);

  useEffect(() => {
    if(librarySelected?.libraryId && typeof onLibrarySelected === 'function'){
      onLibrarySelected(librarySelected);
    }
  }, [librarySelected, onLibrarySelected]);

  return (
    <FormControl sx={{fontSize: 12, minWidth: width ? width: 'auto'}} fullWidth={fullWidth}>
      {variant !== 'standard' ? <InputLabel id="library-select-label">Library</InputLabel>:null}
      <Select 
        size="small"
        labelId="library-select-label"
        value={librarySelected}
        label="Library"
        variant={variant}
        onChange={(e) => setLibraySelected(e.target.value)}
        sx={{ padding: '4px 0 1px', fontSize: 14 }}
        // disable Underline
      >
        {libraryList.map((library, index) => <MenuItem key={index} value={library}>{library.name}</MenuItem>)}
      </Select>
    </FormControl>
  );
}
 
export default React.memo(LibrarySelect);
